import React, { FC, useRef } from "react";
import { ContentManager } from "../content-manager";
import type { OriginatingInstitutionsStreamlineComplianceProps } from "@/types";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const OriginatingInstitutionsStreamlineCompliance: FC<OriginatingInstitutionsStreamlineComplianceProps> = ({
  content,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="originatingInstitutionsStreamlineCompliance">
      <div ref={ref} className="wrapper">
        {content.title && (
          <SplitTextAnimation
            htmlElement={
              <h2 className="originatingInstitutionsStreamlineCompliance--title">
                {content.title}
              </h2>
            }
            isInView={isInView}
          />
        )}
        <div className="originatingInstitutionsStreamlineCompliance--cols">
          {content.textCol1 && (
            <ContentManager
              content={content.textCol1}
              className="originatingInstitutionsStreamlineCompliance--col"
            />
          )}
          {content.textCol2 && (
            <ContentManager
              content={content.textCol2}
              className="originatingInstitutionsStreamlineCompliance--col"
            />
          )}
        </div>
      </div>
    </section>
  );
};
